import { CTE }                    from '../01_core' ;

import { IUsers
       , IWorkgroup }             from './01_model_app_types' ;
import { Path }                   from './02_model_app_path' ;


export const ROUTES: { [screen_name:string]: Path<any> } =
{ [ CTE.SCREEN.LOGIN        ]: new Path< {}         >( [ 'login'     ] )
, [ CTE.SCREEN.WORKGROUPS   ]: new Path< IWorkgroup >( [ 'workgroups', ':workgroup_id', 'users/:user_id' ] )
, [ CTE.SCREEN.USERS        ]: new Path< IUsers     >( [ 'users'     ] )
, [ CTE.SCREEN.JOBS         ]: new Path< IWorkgroup >( [ 'jobs'      ] )
, [ CTE.SCREEN.KEY_MASTERING ]: new Path< IWorkgroup >( [ 'masterings' ] )
, [ CTE.SCREEN.CLIENTS      ]: new Path< IWorkgroup >( [ 'clients'   ] )
, [ CTE.SCREEN.LOADING      ]: new Path< {}         >( [ 'loading'   ] )
, [ CTE.SCREEN.NOT_FOUND    ]: new Path< {}         >( [ 'not-found' ] )
} ;
